/**
 *
 * Speaker Block
 *
 * Handling speaker lightbox
 */

jQuery(document).ready(function () {

jQuery('.speaker-pic-up').click(function() {
    var speakerExpandElementId = jQuery(this).attr('id');
    jQuery('#single-speaker-wrap-expanded-'+speakerExpandElementId).fadeIn();
    // jQuery('body').addClass('colored-background');
});

jQuery('.close-single-speaker-wrap-expanded').click(function() {
    var speakerExpandElementId = jQuery(this).attr('id');
    jQuery('#single-speaker-wrap-expanded-'+speakerExpandElementId).fadeOut();
    // jQuery('body').removeClass('colored-background');
});


});